export default class NavMobileACF {
  constructor() {
    this.toggle = document.querySelector('.mobile-menu-toggle');
    this.nav = document.querySelector('#nav-mobile-acf');
    this.backdrop = document.querySelector('#nav-mobile-acf-backdrop');
    this.closeButton = document.querySelector('.nav-mobile-acf__close');
    this.windowWidth = window.innerWidth;
    
    if (this.toggle && this.nav) {
      this.init();
    }
  }

  init() {
    // Toggle nav
    this.toggle.addEventListener('click', (e) => {
      e.preventDefault();
      this.toggleNav();
    });

    // Close button
    if (this.closeButton) {
      this.closeButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.closeNav();
      });
    }

    // Backdrop click
    if (this.backdrop) {
      this.backdrop.addEventListener('click', () => {
        this.closeNav();
      });
    }

    // Handle clicks inside nav
    this.nav.addEventListener('click', (e) => {
      // Arrow button - show submenu
      if (e.target.closest('.nav-mobile-acf__arrow')) {
        e.preventDefault();
        const arrow = e.target.closest('.nav-mobile-acf__arrow');
        const item = arrow.closest('.nav-mobile-acf__item');
        const submenu = item.querySelector('.nav-mobile-acf__submenu');
        
        if (submenu) {
          // Close any nested submenus inside this item first
          const nestedSubmenus = submenu.querySelectorAll('.nav-mobile-acf__submenu');
          nestedSubmenus.forEach(nested => nested.classList.remove('active'));
          
          // Then open this submenu
          submenu.classList.add('active');
        }
      }

      // Back button - close only the deepest active submenu
      const backButton = e.target.closest('.nav-mobile-acf__back');
      if (backButton) {
        e.preventDefault();
        e.stopPropagation();
        
        // Find ALL active submenus
        const allActiveSubmenus = Array.from(this.nav.querySelectorAll('.nav-mobile-acf__submenu.active'));
        
        if (allActiveSubmenus.length > 0) {
          // Find the deepest one (the one that doesn't contain any other active submenus)
          const deepestActive = allActiveSubmenus.find(submenu => {
            // Check if this submenu contains any other active submenus
            const containsOther = allActiveSubmenus.some(other => {
              return other !== submenu && submenu.contains(other);
            });
            return !containsOther;
          });
          
          // Close only the deepest active submenu
          if (deepestActive) {
            deepestActive.classList.remove('active');
          }
        }
      }

      // Close nav when clicking a link (not in wrapper)
      if (e.target.tagName === 'A' && !e.target.closest('.nav-mobile-acf__link-wrapper')) {
        this.closeNav();
      }

      // Prevent bubbling
      e.stopPropagation();
    });

    // Escape key - close deepest submenu first
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.nav.classList.contains('active')) {
        // Find all active submenus and get the deepest one
        const activeSubmenus = Array.from(this.nav.querySelectorAll('.nav-mobile-acf__submenu.active'));
        if (activeSubmenus.length > 0) {
          // Find the deepest one (the one that contains no other active submenus)
          const deepestSubmenu = activeSubmenus.find(submenu => {
            return !activeSubmenus.some(other => other !== submenu && submenu.contains(other));
          });
          if (deepestSubmenu) {
            deepestSubmenu.classList.remove('active');
          }
        } else {
          this.closeNav();
        }
      }
    });

    // Resize
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        const currentWidth = window.innerWidth;
        if (currentWidth !== this.windowWidth && this.nav.classList.contains('active')) {
          this.closeNav();
        }
        this.windowWidth = currentWidth;
      }, 150);
    });
  }

  toggleNav() {
    this.nav.classList.toggle('active');
    this.toggle.classList.toggle('active');
    
    if (this.backdrop) {
      this.backdrop.classList.toggle('active');
    }
    
    if (this.nav.classList.contains('active')) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
      this.closeAllSubmenus();
    }
  }

  closeNav() {
    this.nav.classList.remove('active');
    this.toggle.classList.remove('active');
    
    if (this.backdrop) {
      this.backdrop.classList.remove('active');
    }
    
    document.body.style.overflow = '';
    this.closeAllSubmenus();
  }

  closeAllSubmenus() {
    const submenus = this.nav.querySelectorAll('.nav-mobile-acf__submenu');
    submenus.forEach(submenu => {
      submenu.classList.remove('active');
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/nav-mobile-acf.js